import React from 'react'
// import useAnimatedNum from '../hooks/useAnimateNumber'
import styles from '../component-styles/progress-circle.module.scss'

function getStatus(percentage: number): [string, string] {
  let color = '#e61969'
  let message = 'Poor'

  if (percentage >= 70) {
    color = '#06b4a2'
    message = 'Great'
  } else if (percentage >= 60) {
    color = '#3effac'
    message = 'Good'
  } else if (percentage >= 40) {
    color = '#ffd80f'
    message = 'Average'
  }

  return [color, message]
}

interface Props {
  percentage: number
  heightWidth: number
}

export default function ProgressCircle({
  percentage,
  heightWidth,
}: Props): React.ReactElement {
  // const animatedPercentage = useAnimatedNum(percentage, 0)
  const animatedPercentage = Math.floor(percentage)

  const radius = 44
  const circumference: number = radius * 2 * Math.PI
  const offset: number =
    circumference - (circumference / 100) * animatedPercentage

  const [statusColor, statusMessage] = getStatus(animatedPercentage)

  return (
    <div
      style={{ height: heightWidth, width: heightWidth }}
      className={styles.container}
    >
      <svg viewBox="-50 -50 100 100" className={styles.svg}>
        <circle className={styles.strokeBg} x="0" y="0" r="44" />
        <circle
          x="0"
          y="0"
          r="44"
          stroke={statusColor}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
        <text
          x="0"
          y="-5%"
          dominantBaseline="middle"
          textAnchor="middle"
          className={styles.percentageText}
        >
          {animatedPercentage}%
        </text>
        <text
          x="0"
          y="20%"
          dominantBaseline="middle"
          textAnchor="middle"
          className={styles.statusMessage}
        >
          {statusMessage}
        </text>
      </svg>
    </div>
  )
}

ProgressCircle.defaultProps = {
  percentage: 0,
  heightWidth: 100,
}
